jQuery(document).ready(function() {
    function recaptcha_submit_handler(e) {
        const form = jQuery(this);
        if (!form.valid()) {
            return false;
        }
        if (!window.grecaptcha) {
            console.warn('Google reCAPTCHA not loaded!');
            return;
        }
        e.preventDefault();
        const site_key_dev = '6LdpAmQqAAAAAMqB1zq9Eztl7bwBBcItkVp0z-Zw';
        const site_key = '6Lcj_mMqAAAAAFszgMbmNaePHihdmPYt13_I5nUZ';
        const action = form.find('input[name="enquiry_action"]').val();
        grecaptcha.ready(function() {
            grecaptcha.execute(site_key, {action: action}).then(function(token) {
                let input = form.find('input[name="grecaptcha-response"]').first();
                if (input.length === 0) {
                    input = jQuery('<input>')
                        .attr('type', 'hidden')
                        .attr('name', 'grecaptcha-response')
                    form.append(input);
                }
                input.val(token);
                form.off('submit', recaptcha_submit_handler).trigger('submit');
            });
        });
    }
    jQuery('.recaptcha-form').on('submit', recaptcha_submit_handler);
});
